export const searchFocusedSelector = (state) => state.ui.header.searchFocused;